"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var generic_view_1 = require("./generic.view");
var route_utils_1 = require("../route.utils");
var xssFilter = require("xss-filters");
var constants_1 = require("../constants");
var REQUEST_URI = constants_1.default.REQUEST_URI, VIEWS = constants_1.default.VIEWS, LEGACY_SETTINGS_URI = constants_1.default.LEGACY_SETTINGS_URI;
function GlobalErrorView(_a) {
    var route = _a.route, content = _a.content;
    var _b = route_utils_1.default(VIEWS.GLOBAL_ERROR, route), query = _b.query, isFlow = _b.isFlow, flow = _b.flow, _c = content.errors, errors = _c === void 0 ? {} : _c, returnLink = isFlow ? REQUEST_URI + "/flow-cancel/default" : REQUEST_URI;
    // Get content.errors for query.type: dataRetrieval, noAgreement and general
    // Any new query type should add new content to content/errors.properties with header, description, button, flowButton
    var queryType = !query.type ? 'general' : xssFilter.uriQueryInHTMLData(query.type);
    var errorContent = errors[queryType] || errors['general'];
    var buttonContent = isFlow && queryType !== 'general' ? errorContent.flowButton : errorContent.button;
    var resultViewData = {
        resultType: 'error',
        headerContent: errorContent.header || '',
        bodyContent: errorContent.description || '',
        buttonData: {
            content: buttonContent || '',
            href: returnLink,
            target: '_top',
            type: ''
        }
    };
    return React.createElement(generic_view_1.default, tslib_1.__assign({}, resultViewData));
}
exports.default = GlobalErrorView;
